export default __webpack_public_path__ + "static/media/uploadfile.f1d82e5d.svg";